export default {
    "Data Record": "ಡೇಟಾ ದಾಖಲೆ",
    "My Storage": "ನನ್ನ ಸಂಗ್ರಹಣೆ",
    "Upgrade": "ನವೀಕರಿಸಿ",
    "Data Size": "ಡೇಟಾ ಗಾತ್ರ",
    "Folders": "ಫೋಲ್ಡರ್‌ಗಳು",
    "Your file is getting upload": "ಫೋಲ್ಡರ್ ಅನ್ನು ಮರುಹೆಸರಿಸಿ",
    "Folder Name": "ಫೋಲ್ಡರ್ ಹೆಸರು",
    "Files": "ಫೈಲುಗಳು",
    "Rename Folder": "ಫೋಲ್ಡರ್ ಅನ್ನು ಮರುಹೆಸರಿಸಿ",
    "Move Folder": "ಫೋಲ್ಡರನ್ನು ಸರಿಸಿ",
    "Delete Folder": "ಫೋಲ್ಡರನ್ನು ಅಳಿಸಿ",
    "Upload": "ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
    "Create Folder": "ಫೋಲ್ಡರ್ ರಚಿಸಿ",
    "Uploading": "ಅಪ್‌ಲೋಡ್  ಮಾಡಲಾಗುತ್ತಿದೆ",
    "Cancel Uploading": "ಅಪ್‌ಲೋಡ್ ಮಾಡುವುದನ್ನು ರದ್ದುಗೊಳಿಸಿ",
    "Are you sure want to cancel ?": "ನೀವು ರದ್ದು ಮಾಡಲು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ?",
    "Yes": "ಹೌದು",
    "No": "ಇಲ್ಲ",
    "Are you sure want to delete ?": "ನೀವು ಅಳಿಸಲು ಖಚಿತವಾಗಿ ಬಯಸುವಿರಾ?",
    "Cancel": "ರದ್ದುಗೊಳಿಸಿ",
    "Delete": "ಅಳಿಸಿ",
    "Rename Folder/File": "ಫೋಲ್ಡರ್ / ಫೈಲ್ ಅನ್ನು ಮರುಹೆಸರಿಸಿ",
    "Folder  Name / File Name": "ಫೋಲ್ಡರ್ ಹೆಸರು / ಫೈಲ್ ಹೆಸರು",
    "Save": "ಉಳಿಸಿ",
    "Move File": "ಫೈಲನ್ನು ಸರಿಸಿ",
    "Move": "ಸರಿಸಿ",
    "Share": "ಹಂಚಿ",
    "Rename": "ಮರುಹೆಸರು ನೀಡಿ",
    "Delete": "ಅಳಿಸಿ",
    "Download": "ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    "No Data Found": "ಡೇಟಾ ಕಂಡುಬಂದಿಲ್ಲ",
    "Search": "ಹುಡುಕಿ...",
    "uploaded successfully": "ಅಪ್‌ಲೋಡ್ ಮಾಡಲಾಗಿದೆ",
    "You can share one file at a time": "ದಯವಿಟ್ಟು ಒಂದು ಸಮಯದಲ್ಲಿ ಒಂದು ಫೈಲ್ ಅನ್ನು ಹಂಚಿಕೊಳ್ಳಿ",
    "Choose your folder and click on move here": "ಫೋಲ್ಡರ್ ಆಯ್ಕೆಮಾಡಿ ಮತ್ತು ಮೂವ್ ಫೈಲ್ ಒತ್ತಿರಿ",
    "You can download one file at time": "ನೀವು ಒಂದು ಸಮಯದಲ್ಲಿ ಒಂದು ಫೈಲ್ ಅನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಬಹುದು",
    "you can rename one file at a time": "ನೀವು ಒಂದು ಸಮಯದಲ್ಲಿ ಒಂದು ಫೈಲ್ ಅನ್ನು ಮರುಹೆಸರಿಸಬಹುದು",
    "Rename successfull": "ಫೈಲ್ ಮರುಹೆಸರಿಸಲಾಗಿದೆ",
    "file Deleted Successfully": "ಫೈಲನ್ನು ಅಳಿಸಲಾಗಿದೆ",
    "Load More": "ಇನ್ನಷ್ಟು ಲೋಡ್ ಮಾಡಿ",
    "No more Data": "ಹೆಚ್ಚಿನ ಡೇಟಾ ಇಲ್ಲ",
    "Insufficient Memory": "आपके पास पर्याप्त जगह नहीं है"

}